/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cov_Sensor_Param_Help_PresenceInputs */



/**
* | output |
* | --- |
* | "The air quality sensor is active during comfort, pre-comfort and night periods. It does not activate during unexpected presence detection" |
*
* @param {Cov_Sensor_Param_Help_PresenceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const cov_sensor_param_help_presence = /** @type {((inputs?: Cov_Sensor_Param_Help_PresenceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cov_Sensor_Param_Help_PresenceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The air quality sensor is active during comfort, pre-comfort and night periods. It does not activate during unexpected presence detection")
	return /** @type {LocalizedString} */ ("Le capteur de qualité de l'air est actif lors des périodes de confort, pré-confort et nuit. Il ne s'active pas lors d'une détection de présence non prévue")
});